document.addEventListener('DOMContentLoaded', function() {
    console.log('Document loaded');
    var style1 = document.createElement('style');
    var styleHeader = document.createElement('style');

    const heroSectionID = 'shopify-section-template--19836390146100__hero_qVYcTr';
    const heroID = '#Hero-template--19836390146100__hero_qVYcTr';

    const bigLogoQuery = '#shopify-section-template--19836390146100__section_yfErPh .logo-block';
   
    //set header as half transparent and blur background
    const headerComp = document.getElementById('header-component');
    const headerRow = document.querySelectorAll('.header__row');
    const headerLogo = document.querySelectorAll('.header-logo');

    styleHeader.innerHTML =
    //'#header-component { backdrop-filter: blur(2px); -webkit-backdrop-filter: blur(2px); }' +
    '.header__row { background-color: rgba(255, 255, 255, 0.5); }' +
    '#glass_blur_overflow { height: 200%;' +
        'width: 100%;' +
        'position: absolute;' +
        'inset: 0;' +
        'z-index: -1;' +
        'backdrop-filter: blur(20px);' +
        '-webkit-backdrop-filter: blur(20px);' +
        'mask-image: linear-gradient(' +
            'to bottom,' +
            'black 0% 50%,' +
            'transparent 50% 100%' +
        ');' +
        'pointer-events: none;' +
    '}' +
    '.header { view-transition-name: none !important; }'
    ;

    

    document.head.appendChild(style1);
    document.head.appendChild(styleHeader);

    document.getElementById(heroSectionID).scrollIntoView();

    //hide header on load
    //headerComp.setAttribute('data-sticky-state', 'idle');

    document.addEventListener('scroll', (event) => {
        let s = document.documentElement.scrollTop, blurVal = s === 0 ? 0 : (s / 20);

        if(blurVal >= 10) {
            //max blur level
            blurVal = 10;
        }

        var brightnessVal;

        if(screen.width < 750) {
            //if mobile
            console.log('mobile');
            brightnessVal = (100 - s / 15);
        }else{
            console.log('desktop');
            brightnessVal = (100 - s / 300);
        }
        if(brightnessVal <= 50) {
            //lowest brightness level
            brightnessVal = 50;
        }
        
        

        var scaleVal = (1 + s / 20 / 100);
        if(scaleVal >= 1.5) {
            //max scale
            scaleVal = 1.5;
        }else if(scaleVal < 1) {
            scaleVal = 1;
        }

        var opacityVal = (100 - s / 5);

        //console.log('blurVal: ' + blurVal + ' ' + s);

        // legacy support for -webkit-backdrop-filter blur
        style1.innerHTML = 
        heroID + ' > .hero__container {' +
            '-webkit-filter: blur(' + blurVal + 'px) !important;' +
            'filter: blur(' + blurVal + 'px) !important;' +
            'transform: scale(' + scaleVal + ');' +
            'filter: brightness(' + brightnessVal + '%);' +
        '}' + 
        heroID + ' > .hero__container > .hero__media-wrapper {' +
            'opacity: ' + opacityVal + '%' +
        '} ' +

        bigLogoQuery + '{' +
            'transform: scale(' + scaleVal + ');' +
        '}'
        ; 

        if(blurVal >= 1) {
            //scrolled
            headerRow[0].style.backgroundColor = 'rgba(255, 255, 255, 0.2)';
        }else{
            //top
            headerRow[0].style.backgroundColor = 'rgba(255, 255, 255, 0)';
        }

    });

    

}, false);